module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAoCAYAAABpYH0BAAAABHNCSVQICAgIfAhkiAAAAAFzUkdCAK7OHOkAAAAEZ0FNQQAAsY8L/GEFAAAACXBIWXMAABJ0AAASdAHeZh94AAAAyUlEQVRoQ+3ZsQnCUBRA0adz2FvY2LuDS7iAE1g4gQu4RHZxAztBcAJFeI0ICT8XfsLnniY/JNUleQnJYr3dvWPGXs9HruZpmVuNZEDIgJABIQNCBoQMCBkQMiBkQMiAkAEhA0LFX2NWx2uu/t0vh8HjpUq/xmzOXa4ibqf9z36f77ljeAVCBoSau4VrcwYmZ+BEmvsnUvsKdAZCzsDkDJyIASEDQj5EoOZeY2rzFoYMCBkQMiBkQMiAkAEhA0IGhAwIGRAyIBLxAS4wY3u71+JzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/tileIcon.png
// module id = 1339
// module chunks = 0